import React from 'react';
import { styled } from '@compiled/react';
import { N0, N200, N800 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { fontFamily, fontSize } from '@atlassian/jira-common-styles/src';
import { useIntl } from '@atlassian/jira-intl';
// eslint-disable-next-line jira/import/no-restricted-paths
import { useIssueCreateSummary } from '../../../../controllers/issue-create-form';
import messages from './messages';

const Summary = () => {
	const { formatMessage } = useIntl();
	const [value, { onChangeSummary }] = useIssueCreateSummary();

	return (
		<Textarea
			autoFocus
			aria-label={formatMessage(messages.summaryLabel)}
			placeholder={formatMessage(messages.summaryPlaceholder)}
			maxLength={255}
			value={value}
			onChange={(event) => onChangeSummary(event.target.value)}
			rows={1}
		/>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Textarea = styled.textarea({
	backgroundColor: token('elevation.surface', N0),
	border: 'none',
	color: token('color.text', N800),
	flex: 1,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontFamily,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSize}px`,
	lineHeight: '28px',
	padding: 0,
	outline: 'none',
	resize: 'none',
	'&::placeholder': {
		color: token('color.text.subtlest', N200),
	},
});

export default Summary;
